<template>
    <div class="page">
        <div class="baner-subpage">
            <div class="container">
                <div class="text">Judaszowce, lecz nie tylko ...</div>
            </div>
        </div>
        <div class="kontakt-info-top">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="item">
                            <div class="boxIcon">
                                <span class="icon-pin1"></span>
                            </div>
                            <div class="text">
                                Szkółkarstwo Ozdobne Olszewscy<br/>
                                Jarosław, Renata Olszewska<br/>
                                ul. Strażacka 20<br/>
                                42-262 Poczesna
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="item">
                            <div class="boxIcon">
                                <span class="icon-phone1"></span>
                            </div>
                            <div class="text">
                                <a href="tel:+48 600 325 709"><b>+48 600 325 709</b></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="item l">
                            <div class="boxIcon">
                                <span class="icon-envelope1"></span>
                            </div>
                            <div class="text">
                                <a href="mailto:jaroslaw.olszewski62@gmail.com"><b>jaroslaw.olszewski62@gmail.com</b></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="map-canvas" >
            <div><iframe style="" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=pl&amp;geocode=50.7199242,19.1615501&amp;q=(Olszewscy%20RJ%20)&amp;ie=UTF8&amp;z=16&amp;t=m&amp;iwloc=near&amp;output=embed"  frameborder="0"></iframe></div><br><br>
        </div>
    </div>


</template>

<script>


    export default {
        components: {

        },
        methods: {

        },
        mounted: function () {


        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Kontakt.vue